<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title" id="projectTitle">Excluir projeto</h5>
    <button type="button" class="close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      Deseja realmente excluir o registro <b>{{ record?.description }}</b> selecionado?
      Após essa operação o mesmo não poderá ser mais recuperado.
    </div>

    <div class="form-group" [formGroup]="deleteForm">
      <input type="password" class="form-control" placeholder="digite sua senha aqui..."
        [ngClass]="{ 'is-invalid': submitted && deleteForm.get('password').hasError('required') }"
        formControlName="password"
      />
      <small class="invalid-feedback" *ngIf="submitted && deleteForm.get('password').hasError('required')">
        Senha não foi informada
      </small>
      <small class="form-text text-muted">Para sua segurança digite no campo acima a sua <b>senha</b> para confirmar operação de remoção do registro.</small>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-link" (click)="activeModal.dismiss()">Voltar</button>
    <button type="button" (click)="delete()" [attr.data-loader]="!submitted" btnloader class="btn btn-danger">
      Confirmar
    </button>
  </div>
</div>
